import Typography from '@mui/material/Typography';

import editIconSrc from 'images/icons/edit.svg';

const rootCss = ({ breakpoints, palette, spacing }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: spacing(2),
  backgroundColor: palette.background.default,
  marginBottom: spacing(2),
  '.QQB-icon': {
    flexShrink: 0,
    width: 40,
    height: 40,
    marginRight: spacing(3),
  },

  [breakpoints.up('sm')]: {
    padding: spacing(4),
  },
});

const QUESTION_BANNER_CONFIG = {
  FillInTheBlank: ['Fill In The Blank', 'Enter your answers in the input fields found in the question.'],
};

export default function QuizQuestionBanner({ className, questionType }) {
  const config = QUESTION_BANNER_CONFIG[questionType];
  if (!config) return null;
  const [title, description] = config;

  return (
    <div className={className} css={rootCss}>
      <img alt="" className="QQB-icon" src={editIconSrc} />
      <div>
        <Typography variant="overline">{title}</Typography>
        <Typography variant="body2">{description}</Typography>
      </div>
    </div>
  );
}
